import * as React from 'react'
import GroupsModalFooter from './GroupsModalFooter'
import GroupsModalHeader from './GroupsModalHeader'
import GroupsDefaultList from './components/GroupsDefaultList'
import GroupsCustomList from './components/GroupsCustomList'
import { useGroupsForm } from '../../context/GroupsFormContext'
import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import { LoaderIcon } from '@/app/features/icons/Loader'

import AddGroupModal from './AddGroupModal'
import { useDriverForm } from '../../context/DriverFormContext'
import ModalLayout from '../shared/ModalLayout'

const GroupsModal = ({
  isOpen,
  close,
  onChange,
  companyId,
  driverName,
}: {
  isOpen: boolean
  onChange: (e: any) => void
  close: () => void
  companyId: string
  driverName?: string
}) => {
  const { groups, isActive, refreshGroups } = useDriverForm()
  const { selected } = useGroupsForm()
  const loading = useLoadingStore(selectLoading)
  const [isAddOpenGroupModal, setIsOpenAddDriverModal] = React.useState(false)

  const confirmGroupAddition = () => {
    try {
      const selectedIds = selected.filter((g) => g).map((g) => g.id)
      onChange(selectedIds)
    } finally {
      close()
    }
  }

  // `return null` pod hookami - patrz `AddDriverModal`.
  if (!isOpen) return null

  return (
    <ModalLayout>
      <div className="tw-flex tw-max-h-[75vh] tw-min-h-[400px] tw-w-full tw-max-w-[640px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
        <GroupsModalHeader close={close} driverName={driverName} />
        <div className="tw-flex-1 tw-overflow-y-auto">
          {loading ? (
            <div className="tw-grid tw-place-items-center tw-pt-8">
              <LoaderIcon className="tw-w-16 tw-animate-spin" />
            </div>
          ) : (
            <>
              <GroupsDefaultList isActive={isActive} />
              <GroupsCustomList groups={groups} />
            </>
          )}
        </div>

        <GroupsModalFooter
          onClick={() => confirmGroupAddition()}
          open={() => setIsOpenAddDriverModal(true)}
        />
      </div>
      {isAddOpenGroupModal && (
        <AddGroupModal
          refreshGroups={refreshGroups}
          companyId={companyId}
          close={() => setIsOpenAddDriverModal(false)}
        />
      )}
    </ModalLayout>
  )
}

export default GroupsModal
